import { render, staticRenderFns } from "./RemoveCompetencyConfirm.vue?vue&type=template&id=08734d64"
import script from "./RemoveCompetencyConfirm.vue?vue&type=script&lang=js"
export * from "./RemoveCompetencyConfirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports